import { IRunTriggerFn } from '../../Features/LoadingBar/LoadingBarActionTypes';
import { ITestProvider } from '../../Features/LoadingBar/loadingBarReducer';
import { Environment } from '../Environment';

export const loadAnuraScript = () => {
  const scriptElement: HTMLScriptElement = document.createElement('script');
  scriptElement.setAttribute('type', 'text/javascript');
  scriptElement.setAttribute('async', '');
  scriptElement.src = `https://script.anura.io/request.js?instance=${Environment.ANURA_INSTANCE_ID}&${Math.floor(1e12 * Math.random() + 1)}`;

  return new Promise<ITestProvider<HTMLScriptElement>>((resolve) => {
    const timeoutId = setTimeout(
      () =>
        resolve({
          status: 'ERROR',
          reason: 'anura api failed to load; timeout reached',
        }),
      3000,
    );

    scriptElement.addEventListener(
      'load',
      () => {
        resolve({ status: 'LOADED', instance: scriptElement });
        clearTimeout(timeoutId);
      },
      false,
    );
    scriptElement.onerror = (event) => {
      resolve({
        status: 'ERROR',
        reason:
          typeof event === 'string'
            ? `anura api failed to load; ${event}`
            : 'anura api failed to load; error encountered while loading script',
      });
      clearTimeout(timeoutId);
    };

    document.head.appendChild(scriptElement);
  });
};

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const waitForAnuraToBeReady = () =>
  new Promise<ITestProvider<IAnuraInstance>>((resolve) => {
    let isTimeoutExceeded = false;
    const timeoutId = setTimeout(() => {
      isTimeoutExceeded = true;
    }, 3000);

    const lookupAnuraInstance = async (): Promise<
      ITestProvider<IAnuraInstance>
    > => {
      while (!isTimeoutExceeded) {
        const instance = Anura.getAnura();
        if (instance) {
          clearTimeout(timeoutId);
          return { status: 'LOADED', instance };
        } else {
          await delay(25);
        }
      }

      return {
        status: 'ERROR',
        reason: 'anura provider did not load; timeout reached',
      };
    };

    lookupAnuraInstance()
      .then(resolve)
      .catch((err) =>
        resolve({
          status: 'ERROR',
          reason:
            err instanceof Error
              ? err.message
              : 'anura provider did not load; unknown error',
        }),
      );
  });

export const executeAnura =
  (anura: IAnuraInstance): IRunTriggerFn =>
  async () => {
    while (!anura.getId() && !anura.getError()) {
      await delay(25);
    }

    const testId = anura.getId();

    return testId
      ? {
          status: 'LOADED',
          value: testId,
        }
      : {
          status: 'ERROR',
          reason: `anura execute error; ${anura.getError() ?? 'unknown failure'}`,
        };
  };
